export const INITIAL_CURRENT_PRODUCT_STATE = {
    sku: '',
    stock: 0,
    productName: '',
    master: false,
    isGroupingProduct: false,
    rotation: '',
    productKey: '',
    productOption: '',
    productType: '',
    shaftLength: '',
    startingMethod: '',
    controlMethod: '',
    productCampaignID: '',
    size: '',
    eCommerceEnabled: '',
    loweredVersion: '',
    power: '',
    transmission: '',
    colourId: '',
    images: [],
    prices: {
        amount: 0,
        currencyCode: '',
    },
    priceDiscountHistory: {
        currency: '',
        history: [],
    },
};
export const LOW_STOCK_THRESHOLD = 10;
export const COUNT_PLACEHOLDER = '{count}';
export const SANTANDER = 'santander';
